import { render, staticRenderFns } from "./goodBrandCategoryList.vue?vue&type=template&id=6d1fbdf1&scoped=true"
import script from "./goodBrandCategoryList.vue?vue&type=script&lang=js"
export * from "./goodBrandCategoryList.vue?vue&type=script&lang=js"
import style0 from "./goodBrandCategoryList.vue?vue&type=style&index=0&id=6d1fbdf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1fbdf1",
  null
  
)

export default component.exports